import { PASSWORD_REGEX, PASSWORD_REQUIREMENTS_MESSAGE } from '@/lib/constants';
import * as yup from 'yup';

export const changePasswordSchema = yup.object({
  password: yup.string().required('Current password is required'),
  newPassword: yup
    .string()
    .required('New password is required')
    .min(8, 'Password must be at least 8 characters long')
    .matches(PASSWORD_REGEX, PASSWORD_REQUIREMENTS_MESSAGE),
});

export type ChangePasswordFormData = yup.InferType<typeof changePasswordSchema>;
